import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import {
  Container,
  Grid,
  Header,
  Button,
  Divider,
  Segment,
  List,
  Image,
  Item,
  Icon,
  Card,
  Search,
  Progress
} from 'semantic-ui-react'

const Airtable = require('airtable')
const base = new Airtable({apiKey: 'keyEr9XzifZuH1Scd'}).base('appOWsqX1TswxQjdZ')

export default class Home extends Component {
  constructor(props) {
      super(props)
      this.state = {
          songs: []
      }
  }

  componentDidMount () {
    var self = this
    let rows = []
    return base('Catalog').select({
      maxRecords: 4,
      view: 'Catalog View'
    }).eachPage(function page (records, fetchNextPage) {
      records.forEach(function (record) {
        rows.push(record)
      })

      fetchNextPage()
    }).then(function () {
      console.log('rows', rows)
      self.setState({songs: rows})
    })

  }

  render () {
    let art = ''
    console.log('rendering...', this.state)
    return (
      <div style={{paddingTop: 30}}>
        <Grid columns={4}>
          <Grid.Row>
            {
              this.state.songs.map((song, x) => {
                if (song.get('Artwork')) {
                  art = song.get('Artwork')[0]
                }
                return (
                  <Grid.Column mobile={16} computer={4}>
                    <Link to={`/song/${song.id}`}>
                        <Card key={x} style={{
                          '&:hover': {'opacity': '0.4'},
                           width: '100%',
                           marginBottom: 40
                         }}>
                        <Image src={art.url} />
                        <Card.Content style={{minHeight: '7em'}}>
                          <Card.Header>
                            {song.get('Song Title')}
                          </Card.Header>
                          <Card.Meta>
                            <span className='date'>
                              {song.get('Artist Title')}
                            </span>
                          </Card.Meta>
                        </Card.Content>
                      </Card>
                    </Link>
                  </Grid.Column>
                )
              })
            }
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/container/home/index.js